import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cancel: 'Cancel',
    errorMessage: 'Oops! There was an unknown error.',
    lockCta: 'Lock this card',
    lockSubtitle: 'You can still unlock it anytime in your card settings.',
    lockSuccess: 'This card was successfully blocked.',
    lockTitle: 'Are you sure you want to lock this card?',
    permanentLockCta: 'Lock this card',
    permanentLockSubtitle:
      'This card will be permanently locked. You can order a new card from the Shine mobile app.',
    permanentLockSuccess: 'This card was successfully locked.',
    permanentLockTitle: 'Are you sure you want to permanently lock this card?',
    unlockCta: 'Unlock my card',
    unlockSubtitle:
      'Unlock this card in a second. You can use it immediately afterwards.',
    unlockSuccess: 'This card was successfully unlocked.',
    unlockTitle: 'This card was locked temporarily. Unlock it to use it again!',
  },
  fr: {
    cancel: 'Annuler',
    errorMessage: 'Oups\u00a0! Une erreur inconnue est survenue.',
    lockCta: 'Bloquer cette carte',
    lockSubtitle:
      'Vous pourrez la débloquer à tout moment dans les paramètres de cette carte.',
    lockSuccess: 'Cette carte a bien été bloquée.',
    lockTitle: 'Êtes-vous sûr de vouloir bloquer cette carte bancaire\u00a0?',
    permanentLockCta: 'Bloquer cette carte',
    permanentLockSubtitle:
      'Cette carte sera définitivement bloquée. Vous pouvez néanmoins en recommander une nouvelle via l‘application mobile Shine.',
    permanentLockSuccess: 'Cette carte a bien été bloquée.',
    permanentLockTitle:
      'Êtes-vous sûr de vouloir définitivement bloquer cette carte bancaire\u00a0?',
    unlockCta: 'Débloquer cette carte',
    unlockSubtitle:
      'Débloquez la carte bancaire en une seconde\u00a0: elle peut être utilisée immédiatement après.',
    unlockSuccess: 'Cette carte a bien été débloquée.',
    unlockTitle:
      'Cette carte a été bloquée temporairement. Débloquez-la pour pouvoir l‘utiliser à nouveau\u00a0!',
  },
} as const);

export default locales;
